export default () => {

  const $hamburgerNav = $('.mobile-menu'),
        $hamburgerNavNav = $('.mobile-menu-nav'),
        $panels = $('.mobile-menu-main-panel'),
        $userButtons = $('.mobile-menu-user-buttons'),
        $userPanel = $('.mobile-menu-main-user-panel')
  ;

  $('.js-mobile-menu-toggle').on('click', () => {
    $('html').attr('data-mobile-menu', 'open');
    $hamburgerNav.attr('aria-hidden', 'false');
  });

  $('.js-mobile-menu-close, .js-blocker').on('click', () => {
    $('html').attr('data-mobile-menu', 'closed');
    $hamburgerNav.attr('aria-hidden', 'true');
  });

  $(document).keydown((event) => {
    if (event.keyCode === 27) {
      $('html').attr('data-mobile-menu', 'closed');
      $hamburgerNav.attr('aria-hidden', 'true');
    }
  });

  $('.js-mobile-menu-next').on('click', (e) => {
    e.preventDefault();
    const $panel = $(e.currentTarget).next(),
          height = $panel.height() + 100
    ;
    $hamburgerNav.attr('data-level', '2');
    $panel.attr('aria-hidden', 'false');
    $hamburgerNavNav.css('height', height);
    $userButtons.fadeOut(250);
  });

  $('.js-my-account').on('click', (e) => {
    e.preventDefault();
    const $panel = $userPanel,
          height = $panel.height() + 100
    ;
    $hamburgerNav.attr('data-level', '2');
    $panel.attr('aria-hidden', 'false');
    $hamburgerNavNav.css('height', height);
    $userButtons.fadeOut(250);
  });

  $('.js-mobile-menu-back').on('click', () => {
    $hamburgerNavNav.css('height', '');
    $hamburgerNav.attr('data-level', '1');
    $panels.attr('aria-hidden', 'true');
    $userPanel.attr('aria-hidden', 'true');
    $userButtons.fadeIn(250);
  });

};
